import { get, keyBy, forEach } from 'lodash';

function validateProcedureControls(caseConf, nodeInfo) {
  const treatments = caseConf._treatments || [];
  const treatmentsById = keyBy(treatments, 'id');
  const errors = [];
  const warnings = [];

  const ignore = (id) => {
    // Bed rail procedures can't be enabled/disabled, so ignore
    // Expose procedures (_REPLACED and _REMOVED) are handled elsewhere
    return id === 'LOWER_BED_RAIL' || id === 'RAISE_BED_RAIL' || id.includes('_REPLACED') || id.includes('_REMOVED');
  };

  // Action nodes
  nodeInfo.actionNodes.forEach((node) => {
    const procedureActionTypes = ['PROCEDURE', 'COMPRESSION', 'PERSONAL_PROTECTIVE_EQUIPMENT'];
    const action = get(node, 'data.action');
    if (action && procedureActionTypes.includes(action.type)) {
      if (ignore(action.id)) {
        return;
      }
      const treatment = treatmentsById[action.id];
      if (!treatment || !treatment.options.enabled) {
        const label = get(treatment, 'name.en', action.id);
        warnings.push(procedureWarning(`${label} is used in case logic but is not enabled`, action.id, undefined));
        warnings.push(caseLogicWarning(`${label} is not enabled`, node.id, undefined));
      }
    }
  });


  // Check nodes
  nodeInfo.checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      const procedureCheckTypes = ['PROCEDURE', 'COMPRESSION_ADMINISTERED', 'PERSONAL_PROTECTIVE_EQUIPMENT'];
      if (procedureCheckTypes.includes(check.type)) {
        if (ignore(check.id)) {
          return;
        }
        const treatment = treatmentsById[check.id];

        if (!treatment || !treatment.options.enabled) {
          const label = get(treatment, 'name.en', check.id);
          warnings.push(procedureWarning(`${label} is used in case logic but is not enabled`, check.id, undefined));
          warnings.push(caseLogicWarning(`${label} is not enabled`, node.id, checkKey));
        } else if (check.ids) {
          const options = get(treatment, 'options.componentOptions', {});

          check.ids.forEach(id => {
            if (!options[id] || !options[id].toggled) {
              warnings.push(procedureWarning(`${id} is used in case logic but is not enabled`, check.id, id));
              warnings.push(caseLogicWarning(`${id} is not enabled`, node.id, checkKey, id));
            }
          });
        }
      }
    });
  });

  return {
    errors,
    warnings,
  };
}

function procedureWarning(message, actionId, componentId) {
  return {
    message,
    category: 'procedures',
    field: '_treatments',
    id: actionId,
    metadata: {
      componentId,
      scope: 'control',
    },
  };
}

function caseLogicWarning(message, nodeId, checkKey, componentId) {
  return {
    message,
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      checkKey,
      componentId,
      scope: 'control',
    },
  };
}

export default validateProcedureControls;
